import { useMemo } from 'react'

import { useModals, useFilters, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateProviderPackageModal from '@modals/CreateProviderPackageModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateProviderPackageModal: {
      closeModal: () => setState({ showCreateProviderPackageModal: false }),
      createProviderPackage: payload => handleCallbackAction(payload),
    },
  }
  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateProviderPackageModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateProviderPackageModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateProviderPackageModal: (payload) => {
        setModalData('CreateProviderPackageModal', payload)
        setState({ showCreateProviderPackageModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateProviderPackageModal
          callbacks={callbacks('CreateProviderPackageModal', setState)}
          showModal={showCreateProviderPackageModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
